
import { ErrorBlock } from 'antd-mobile';
import * as React from 'react';
import { ComponentProps, FC } from 'react';
type ErrorBlockProps = ComponentProps<typeof ErrorBlock>

interface BaseErrorBlockProps extends ErrorBlockProps {
}
const BaseErrorBlock: FC<BaseErrorBlockProps> = (props) => {
  const { ...restProps } = props;
  return (
    <ErrorBlock {...restProps} />
  )
};

export default BaseErrorBlock;
